// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/admin.scss
// module id = 34
// module chunks = 0